/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface DatapointvaluesDPIDValueItem {
  /** the DPID's Data Type */
  dataType: DpiddataserviceDataValueType;
  /** the DPID's URN */
  urn: string;
  /**
   * the DPID's value to be saved
   * For a non-composite, non-repeatable item, "value" will be one of:
   * `string`, `integer`, `boolean`,`[]string`, `[]integer`.
   * For a composite, repeatable item, "value" will have the following shape:
   * `[]{ operation: "CREATE" | "UPDATE" | "DELETE", values: []DPIDValueItem }`
   */
  value?: any;
}

export interface DatapointvaluesSaveDPIDsBody {
  /** The array of dataPointValues that are being submitted */
  dataPointValues: DatapointvaluesDPIDValueItem[];
  /** The current life application's reference ID */
  referenceID: string;
}

export interface DatapointvaluesErrorResponse {
  message: string;
}

export interface DatapointvaluesGetResponse {
  dataPointValues: Record<string, any>;
}

export type DpiddataserviceDataValueType =
  | "text"
  | "date"
  | "timestamp"
  | "decimal"
  | "integer"
  | "boolean"
  | "text_list"
  | "integer_list"
  | "composite";

export interface InterviewdataErrorResponse {
  message: string;
}

export interface InterviewdataGetNextInterviewSectionURLBody {
  interviewURN: string;
  referenceID: string;
  sectionURN?: string;
}

export interface InterviewdataGetResponse {
  formValues: Record<string, any>;
  interviewDisplayName: string;
  schema: any;
}

export interface InterviewdataNextInterviewSectionURLResponse {
  isInternal: boolean;
  url: string;
}

export interface SequentialinterviewsSubmitInterviewSectionDataBody {
  /** The array of dataPointValues that are being submitted */
  dataPointValues: DatapointvaluesDPIDValueItem[];
  /** The current interview URN */
  interviewURN: string;
  /** The current life application's reference ID */
  referenceID: string;
  /** The current section URN */
  sectionURN: string;
}

export interface SequentialinterviewsErrorResponse {
  message: string;
}

export interface SequentialinterviewsPostResponse {
  isInternal: boolean;
  url: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Life BFF API
 * @version 0.0.1
 * @externalDocs https://github.com/policygenius/life-bff
 * @contact
 *
 * This is the API for the Life BFF, which is the backend service for the Life Consumer client-side funnel.
 * It serves as the interface between the funnel and downstream services in the Policygenius architecture.
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  dataPointValues = {
    /**
     * @description Given a list of DataPointID urns, returns a map of Interview Service DataPointIDs and their corresponding stored values.
     *
     * @tags Data Point Values
     * @name DataPointValuesDetail
     * @summary Provides a map of Data Point Values
     * @request GET:/data-point-values/{uuid}
     */
    dataPointValuesDetail: (
      uuid: string,
      query: {
        /** The list of DataPointID urns to query for the provided uuid */
        urns: string[];
        /** The reference ID of the current life application */
        referenceID: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DatapointvaluesGetResponse, DatapointvaluesErrorResponse>({
        path: `/data-point-values/${uuid}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Given a list of Data Point IDs with urn, value, and dataType, saves the value for each to the DPID Data Service.
     *
     * @tags Data Point Values
     * @name DataPointValuesCreate
     * @summary Saves a list of Data Point Values
     * @request POST:/data-point-values/{uuid}
     */
    dataPointValuesCreate: (uuid: string, body: DatapointvaluesSaveDPIDsBody, params: RequestParams = {}) =>
      this.request<void, DatapointvaluesErrorResponse>({
        path: `/data-point-values/${uuid}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),
  };
  interviewNextSection = {
    /**
     * @description Given a customer UUID, life reference ID, interview URN, and an optional section URN, returns URL to next (or first) section and whether the URL is internal.
     *
     * @tags Sequential Interviews
     * @name InterviewNextSectionCreate
     * @summary Retrieves the next or first section of an interview
     * @request POST:/interview-next-section/{uuid}
     */
    interviewNextSectionCreate: (
      uuid: string,
      body: InterviewdataGetNextInterviewSectionURLBody,
      params: RequestParams = {},
    ) =>
      this.request<InterviewdataNextInterviewSectionURLResponse, InterviewdataErrorResponse>({
        path: `/interview-next-section/${uuid}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  interviewSectionAndData = {
    /**
     * @description Given an interview URN, a section URN, and a life reference ID, return an interview section, the users DPID values, and interview's displayName
     *
     * @tags Sequential Interviews
     * @name InterviewSectionAndDataDetail
     * @summary Gets a section and its values
     * @request GET:/interview-section-and-data/{uuid}
     */
    interviewSectionAndDataDetail: (
      uuid: string,
      query: {
        /** The URN of the interview */
        interviewURN: string;
        /** The URN of the section */
        sectionURN: string;
        /** The reference ID of the current life application */
        referenceID: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<InterviewdataGetResponse, InterviewdataErrorResponse>({
        path: `/interview-section-and-data/${uuid}`,
        method: "GET",
        query: query,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Given a list of DataPointID values, saves those values in the DPID Data Service and returns the next section to navigate to
     *
     * @tags Sequential Interviews
     * @name InterviewSectionAndDataCreate
     * @summary Saves the given DataPoint values and returns the next section to navigate to
     * @request POST:/interview-section-and-data/{uuid}
     */
    interviewSectionAndDataCreate: (
      uuid: string,
      body: SequentialinterviewsSubmitInterviewSectionDataBody,
      params: RequestParams = {},
    ) =>
      this.request<SequentialinterviewsPostResponse, SequentialinterviewsErrorResponse>({
        path: `/interview-section-and-data/${uuid}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
